import { createContext } from "react";
import siteImage from "@/assets/images/website-meta.png";

export const SiteMetadataContext = createContext();

export const SiteMetadataProvider = ({ children }) => {
  const siteMetadata = {
    siteTitle: "Stanley Yeo",
    siteDescription: "The counterintuitive resources for designers to win",
    siteImage,
    siteImageAlt: "Stanley Yeo logo",
    siteUrl: "https://stanleyyeo.com",
    siteLang: "en",
    siteXUsername: "@imstanleyyeo",
  };

  return (
    <SiteMetadataContext.Provider value={siteMetadata}>
      {children}
    </SiteMetadataContext.Provider>
  );
};
